import { render, staticRenderFns } from "./DevLogin.vue?vue&type=template&id=48327140&scoped=true&"
import script from "./DevLogin.vue?vue&type=script&lang=js&"
export * from "./DevLogin.vue?vue&type=script&lang=js&"
import style0 from "./DevLogin.vue?vue&type=style&index=0&id=48327140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48327140",
  null
  
)

export default component.exports